import { Stepper, StyledHeader } from '@clickcease/cc-client-components-lib'
import React from 'react'

import { StepWizardObj } from './WizardHeader.models'
import { HeaderContainer, StepperContainer } from './WizardHeader.styled'

export interface WizardHeaderProps {
  currentStep: number
  steps: StepWizardObj[]
  onChangeStep: (step: number) => void
  isEnabled?: boolean
  disableBackToFirstStep?: boolean
  blockedSteps?: number[]
}

export const WizardHeader = ({
  currentStep,
  onChangeStep,
  steps,
  isEnabled,
  blockedSteps,
}: WizardHeaderProps) => {
  const progressBarSetStep = (step: number) => {
    // user who finished setup allowed to go forward on steps
    if (isEnabled && step > 1 && step < 7 && !blockedSteps?.includes(step)) {
      onChangeStep(step)
    } else if (step < currentStep && step > 1 && !blockedSteps?.includes(step)) {
      onChangeStep(step)
    }
  }

  const currentIndexOfStep = currentStep - 1

  return (
    <HeaderContainer>
      <StyledHeader variant={'h4'}>{steps[currentIndexOfStep].title ?? ''}</StyledHeader>
      <StepperContainer>
        <Stepper steps={steps.length} currentStep={currentStep} onChangeStep={progressBarSetStep} />
      </StepperContainer>
    </HeaderContainer>
  )
}
